import type { ReservationStatus } from "@features/reservation/model/types";

export const STATUS_CHIP_MAP: Record<ReservationStatus, { labelKey: string; color: "success" | "error" | "warn" }> = {
  OCCUPIED: { labelKey: "confirmed", color: "success" },
  CANCELLED: { labelKey: "cancelled", color: "error" },
  PENDING: { labelKey: "pending", color: "warn" },
};
